import { EntityList } from "../../components/entity-management";
import { api } from "../../services/api";

const territoryConfig = {
  queryKey: "search-territories",
  api: {
    getList: () => api.getTerritories(),
    create: (data: { name: string }) => api.createTerritory(data),
    update: (id: string, data: { id?: string; name: string }) => api.updateTerritory(id, data),
    delete: (id: string) => api.deleteTerritory(id),
  },
  labels: { entityName: "Territory", entityNamePlural: "Territories" },
};

export function TerritoryList() {
  return <EntityList config={territoryConfig} />;
}
